import { useCallback } from "react";
import axiosInstance from "../../service/axiosInstance";
import { bbPeriodAPI, inventoryAPI } from "../../service/api";
import { GET } from "../constants";
import { IBBPeriod } from "../../interfaces";

const useBbPeriods = () => {
  const getBbPeriodByBorrowerId = useCallback(async (borrowerId: number) => {
    try {
      const response = await axiosInstance.request({
        url: bbPeriodAPI.FIND_BY_BORROWER_ID,
        method: GET,
        params: {
          borrowerId,
          sortBy: 'endDate,ASC'
        }
      });
      return response.data.content as IBBPeriod[];
    } catch (error) {
      console.log('GET BB PERIOD BY BORROWER ID ERROR: ', error);
      return [];
    }
  }, []);

  const getAvailableBbPeriodsInInventoryReport = useCallback(async (borrowerId: number, invCollateralId: number) => {
    try {
      const response = await axiosInstance.request({
        url: inventoryAPI.GET_INELIGIBLE_BB_PERIODS,
        method: GET,
        params: {
          borrowerId,
          invCollateralId
        }
      });
      return response.data as number[];
    } catch (error) {
      console.log('GET AVAILABLE BB PERIODS IN INVENTORY REPORT ERROR: ', error);
      return [];
    }
  }, []);

  const getBbPeriodOptions = useCallback(async (borrowerId: number, invCollateralId: number) => {
    const bbPeriods = await getBbPeriodByBorrowerId(borrowerId);
    const availableBbPeriodIds = await getAvailableBbPeriodsInInventoryReport(borrowerId, invCollateralId);
    const availableBbPeriods = bbPeriods.filter(bbPeriod => availableBbPeriodIds.includes(bbPeriod.recordId as number));
    return availableBbPeriods;
  }, [])

  const selectBbPeriodByParameter = useCallback((bbPeriodId: number, bbPeriods: IBBPeriod[]) => {
    const bbPeriodOnParameter = bbPeriods.find(period => period.recordId === bbPeriodId);
    const selected = bbPeriodOnParameter ?? null;
    return selected;
  }, [])

  return {
    getBbPeriodByBorrowerId,
    getAvailableBbPeriodsInInventoryReport,
    getBbPeriodOptions,
    selectBbPeriodByParameter
  };
};

export default useBbPeriods;
